import { Group } from '@lumapps/groups/types';
import { User } from '@lumapps/user/types';

export enum MemberRoles {
    manager = 'MANAGER',
    ambassador = 'AMBASSADOR',
}

export enum MemberType {
    user = 'user',
    group = 'group',
}

export enum MemberPermissions {
    CAN_ACCESS_BASIC_DATA = 'CAN_ACCESS_BASIC_DATA',
    CAN_ACCESS_ALL_SHARES_DATA = 'CAN_ACCESS_ALL_SHARES_DATA',
    CAN_MANAGE_PROGRAM_DATA = 'CAN_MANAGE_PROGRAM_DATA',
    CAN_MANAGE_MANAGERS = 'CAN_MANAGE_MANAGERS',
    CAN_MANAGE_AMBASSADORS = 'CAN_MANAGE_AMBASSADORS',
    CAN_MANAGE_TOPICS = 'CAN_MANAGE_TOPICS',
    CAN_MANAGE_SHAREABLE_CONTENTS = 'CAN_MANAGE_SHAREABLE_CONTENTS',
    CAN_SHARE_SHAREABLE_CONTENTS = 'CAN_SHARE_SHAREABLE_CONTENT',
}

/**
 * The item we get from of /program-membership (see /social-advocacy/sa-members/api/index.ts)
 */
export interface Member {
    id: string;
    role: MemberRoles;
    memberType: MemberType;
    user?: User;
    group?: Group;
    permissions: Array<MemberPermissions>;
}
